import { getPricePerIntervalLength } from '@/composables/getPricePerIntervalLength'
import { ProductId, type Plan, type PlanCurrency, type PlanResult } from '@/types'

const reducePlanResult = (plan: PlanResult): Plan => {
  const {
    autoRenew,
    code,
    name,
    intervalLength,
    currencies,
    currentlyOffered,
    customFields,
    planProduct: planProductResult,
    planSet,
    trialLength,
    trialUnit: trialUnitPlural,
    trialRequiresBillingInfo
  } = plan

  const featureField = customFields?.find((field: any) => field.name === 'planFeature')
  const interval = intervalLength === 12 ? 'yearly' : 'monthly'
  const intervalAsNoun = intervalLength === 12 ? 'year' : 'month'

  const planProduct = planProductResult || ProductId.Arcade

  const planCurrencies = currencies.map((cur: PlanCurrency) => {
    const { currency, unitAmount, setupFee } = cur
    const pricePerIntervalLength = getPricePerIntervalLength(`${unitAmount}`, intervalLength)
    return {
      currency,
      basePrice: unitAmount,
      unitAmount,
      pricePerIntervalLength,
      setupFee
    }
  })

  const trialUnitMappings = {
    days: 'day',
    weeks: 'week',
    months: 'month',
    years: 'year'
  }

  const trialUnit = trialUnitMappings[trialUnitPlural as keyof typeof trialUnitMappings] || trialUnitPlural

  return {
    autoRenew,
    code,
    currentlyOffered,
    name,
    interval,
    intervalLength,
    intervalAsNoun,
    planCurrencies,
    planProduct,
    planSet,
    featureFilter: featureField?.value,
    trialLength,
    trialUnit,
    trialRequiresBillingInfo
  }
}

export default reducePlanResult
